import { useQuery } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";

export interface TAuditLog {
  id: number;
  admin_id: number;
  admin_name: string;
  action: string;
  entity_type: string;
  entity_id: number | null;
  entity_name: string | null;
  description: string | null;
  ip_address: string | null;
  created_at: string;
}

type AuditLogParams = {
  admin_id?: number;
  entity_type?: string;
  entity_id?: number;
  page?: number;
  limit?: number;
};

export const useAuditLogs = (params: AuditLogParams = {}) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.AUDIT_LOGS, params],
    queryFn: () => client.get(API_ENDPOINTS.AUDIT_LOGS, { params }),
    select: (res: any) => ({
      data: res.data.data as TAuditLog[],
      total: res.data.extra?.total ?? 0,
    }),
    refetchOnWindowFocus: false,
  });
};
